import { apiCallCenter } from '@/plugins/axios'

export default {
  getConfig() {
    return apiCallCenter().get('/configcallcenter')
  },
  getTags() {
    return apiCallCenter().get('/configcallcenter/tags')
  },
  putConfig(form){
    return apiCallCenter().put('/configcallcenter', form)
  }
}
